export function uid(prefix: string) {
  return `${prefix ? `${prefix}-` : ''}${Math.random().toString(36).substring(2, 9)}`;
}
